/* La Fleury — selector Horus / Ra (snippets/lf-pair-picker.liquid).
   Al pulsar el otro cojín se pide su ficha con la Section Rendering API y se cambia
   la sección de producto entera (fotos, precio, botón de compra) sin recargar. Si algo
   falla, se navega normal al enlace. */
(function () {
  if (window.__lfPair) return;
  window.__lfPair = true;

  var cache = {};

  function sectionOf(el) {
    var sec = el.closest('.shopify-section');
    return sec && sec.id.indexOf('shopify-section-') === 0 ? sec : null;
  }

  function sectionUrl(href, sec) {
    var id = sec.id.replace('shopify-section-', '');
    return href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id);
  }

  function load(href, sec) {
    var url = sectionUrl(href, sec);
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      });
      cache[url].catch(function () { delete cache[url]; });
    }
    return cache[url];
  }

  // Precarga al acercar el ratón o el dedo: el cambio queda instantáneo.
  ['mouseover', 'touchstart', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var a = e.target.closest && e.target.closest('a.lf-pair__opt[data-lf-swap]');
      var sec = a && sectionOf(a);
      if (sec) load(a.href, sec);
    }, { passive: true });
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.lf-pair__opt');
    if (!a) return;
    if (!a.hasAttribute('data-lf-swap')) { e.preventDefault(); return; }
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var sec = sectionOf(a);
    if (!sec || !window.fetch || !window.DOMParser) return;
    e.preventDefault();

    var href = a.href;
    sec.classList.add('lf-pair-loading');
    load(href, sec).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var neu = doc.getElementById(sec.id);
      if (!neu) throw new Error('sin sección');
      sec.replaceWith(neu);
      var t = doc.querySelector('.product__title h1');
      if (t) document.title = document.title.replace(/^[^–|-]+/, t.textContent.trim() + ' ');
      try { history.replaceState(history.state, '', href); } catch (err) {}
      document.dispatchEvent(new CustomEvent('lf:swap'));
      var picked = neu.querySelector('a.lf-pair__opt.is-current');
      if (picked) picked.focus({ preventScroll: true });
    }).catch(function () {
      window.location.href = href;
    });
  });
})();
